var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGmail(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3751 10.6027H12.6479C12.6479 11.3023 12.6479 12.7015 12.6436 13.4011H16.5418C16.3925 14.1007 15.8628 15.0802 15.1145 15.5734C15.1138 15.5727 15.1131 15.5776 15.1116 15.5769C14.1167 16.2338 12.8037 16.3829 11.8288 16.187C10.3007 15.8833 9.09134 14.7752 8.60032 13.3675C8.60317 13.3654 8.60532 13.3459 8.60746 13.3445C8.30012 12.4714 8.30012 11.3023 8.60746 10.6027H8.60675C9.00272 9.31683 10.2485 8.14359 11.7788 7.82247C13.0096 7.56152 14.3983 7.84416 15.4197 8.79982C15.5555 8.6669 17.2995 6.96405 17.4303 6.82553C13.9409 3.66541 8.35373 4.77708 6.2631 8.85789H6.26239C6.26239 8.85789 6.2631 8.85789 6.25882 8.86558C5.22458 10.87 5.26747 13.2318 6.26596 15.1404C6.2631 15.1425 6.26096 15.1438 6.25882 15.1459C7.16368 16.902 8.81045 18.2487 10.7946 18.7615C12.9024 19.3142 15.5848 18.9364 17.3817 17.3112C17.3824 17.3119 17.3831 17.3126 17.3838 17.3133C18.9062 15.9421 19.854 13.6061 19.3751 10.6027Z",
    fill: "#616161"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.6c1b33ac4a526e8a3dfd1a5f61748dba.svg";
export { ForwardRef as ReactComponent };